




































































































































































































































































































import Vue from "vue"
import CodGroup, { ICodGroup } from "@/components/new-parcel-groups/CodGroup.vue"
import IdCheckGroup, { IIdCheckGroup } from "@/components/new-parcel-groups/IdCheckGroup.vue"
import DeskDeliveryGroup, { IDeskDeliveryGroup } from "@/components/new-parcel-groups/DeskDeliveryGroup.vue"
import FoodGroup, { IFoodGroup } from "@/components/new-parcel-groups/FoodGroup.vue"
import { CreateParcelModel } from "@/model/new-parcel-model/create-parcel-model"
import { ShipmentDeskDelivery } from "@/model/entity/shipment/shipment-desk-delivery"
import ExchangeGroup, { IExchangeGroup } from "@/components/new-parcel-groups/ExchangeGroup.vue"
import { ShipmentIdCheck } from "@/model/entity/shipment/shipment-id-check"
import { ParcelGoods } from "@/model/entity/shipment/parcel-goods"
import * as _ from "lodash"
import { setDefaultLevel } from "loglevel"
import { DpdProductVariant } from "@/model/new-parcel-model/dpd-product/dpd-product-variant"

export interface IAdditionalOptionsGroup extends Vue {
  getDeskDelivery(): ShipmentDeskDelivery

  getIdCheck(): ShipmentIdCheck

  getFood(): ParcelGoods

  setDeskDelivery(shipmentDeskDelivery: ShipmentDeskDelivery): void

  setIdCheck(shipmentIdCheck: ShipmentIdCheck): void

  setFood(parcelGoods: ParcelGoods): void

  clearAll(): void
}

export type TFood = "fresh" | "food" | "frozen"

const codAbbr = "COD"
const sameDayAbbr = "SD"
const b2cAbbr = "B2C"

export default Vue.extend({
  components: {
    CodGroup,
    IdCheckGroup,
    DeskDeliveryGroup,
    FoodGroup,
    ExchangeGroup
  },
  data() {
    return {
      idCheckValidated: true,
      deskDeliveryValidated: true,
      codValidated: true,
      foodValidated: true,
      shipFromShop: false,
      food: null as TFood | null
    }
  },
  props: {
    createParcelModel: {
      type: CreateParcelModel,
      required: true
    },
    parcelNumber: {
      type: Number,
      required: true
    },
    country: {
      type: Object,
      required: true
    },
    additionalOptionsValidated: {
      type: Boolean,
      required: true
    },
    hasProductVariant: {
      type: Boolean,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    sfsChecked: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    clearAll() {
      const codGroup = this.$refs.codGroup as ICodGroup
      const idCheckGroup = this.$refs.idCheckGroup as IIdCheckGroup
      const deskDeliveryGroup = this.$refs.deskDeliveryGroup as IDeskDeliveryGroup
      const exchangeGroup = this.$refs.exchangeGroup as IExchangeGroup
      const foodGroup = this.$refs.foodGroup as IFoodGroup
      this.shipFromShop = false
      this.setDefaultFoodProduct()
      codGroup.clearAll()
      idCheckGroup.clearAll()
      deskDeliveryGroup.clearAll()
      exchangeGroup.clearAll()
      foodGroup.clearAll()
    },
    checkFoodProductAndOption(inputOption: string): boolean {
      return this.createParcelModel.dpdProductVariants.some((el: DpdProductVariant) => {
        return el.wsTextCode.includes(this.food.toString().toUpperCase())
          && el.wsTextCode.includes(inputOption)
      })
    },
    getDeskDelivery(): ShipmentDeskDelivery {
      return (this.$refs.deskDeliveryGroup as IDeskDeliveryGroup).getDeskDelivery()
    },
    setDeskDelivery(shipmentDeskDelivery: ShipmentDeskDelivery) {
      const deskDeliveryGroup = this.$refs.deskDeliveryGroup as IDeskDeliveryGroup
      deskDeliveryGroup.setDeskDelivery(shipmentDeskDelivery)
    },
    getIdCheck(): ShipmentIdCheck {
      return (this.$refs.idCheckGroup as IIdCheckGroup).getIdCheck()
    },
    getFood(): ParcelGoods {
      return (this.$refs.foodGroup as IFoodGroup).getFood()
    },
    setIdCheck(shipmentIdCheck: ShipmentIdCheck) {
      const idCheckGroup = this.$refs.idCheckGroup as IIdCheckGroup
      idCheckGroup.setIdCheck(shipmentIdCheck)
    },
    emitValidation() {
      this.$emit(
        "update:additionalOptionsValidated",
        this.idCheckValidated && this.deskDeliveryValidated && this.codValidated && this.foodValidated
      )
    },
    isb2CDisabled(): boolean {
      if (this.createParcelModel.dpdProduct.type === "DPD_HOME" || this.createParcelModel.dpdProduct.type === "DPD_LIMITED_QUANTITY_HOME") {
        return true
      }
      if (this.isFoodProduct) {
        const enabled = this.checkFoodProductAndOption(b2cAbbr)
        if (!enabled) {
          this.createParcelModel.createParcelModelExtensions.b2c.value = false
        }
        return !enabled
      }
      return !this.createParcelModel.createParcelModelExtensions.b2c.enabled
        || !this.hasProductVariant
        || this.readonly
    },
    isCodDisabled(): boolean {
      if (this.isFoodProduct) {
        const enabled = this.checkFoodProductAndOption(codAbbr)
        if (!enabled) {
          this.createParcelModel.createParcelModelExtensions.cashOnDelivery.value = false
        }
        return !enabled
      }
      return !this.createParcelModel.createParcelModelExtensions.cashOnDelivery.enabled
        || !this.hasProductVariant
        || this.readonly
    },
    isSameDayEnabled(): boolean {
      if (this.isFoodProduct) {
        const enabled = this.checkFoodProductAndOption(sameDayAbbr)
        if (!enabled) {
          this.createParcelModel.createParcelModelExtensions.cashOnDelivery.value = false
        }
        return !enabled
      }
      return !this.createParcelModel.createParcelModelExtensions.sameDay.enabled
        || !this.hasProductVariant
        || this.readonly
    },
    isReturnParcel() {
      return !this.createParcelModel.createParcelModelExtensions.returnParcel.enabled
        || this.readonly
    },
    setShipFromShop() {
      if (this.readonly) {
        this.shipFromShop = this.sfsChecked
      }
    },
    checkFoodProduct(foodProduct: string) {
      if (this.isFoodProduct) {
        const splitedArr = _.uniq(this.createParcelModel.dpdProductVariants
          .map(el => el.wsTextCode.split("-")).flat())
        return splitedArr.includes(foodProduct)
      }
      return false
    },
    setDefaultFoodProduct() {
      if (this.food) {
        return
      }
      if (this.isFoodProductFresh) {
        this.food = "fresh"
        return
      }
      if (this.isFoodProductFood) {
        this.food = "food"
        return
      }
      if (this.isFoodProductFrozen) {
        this.food = "frozen"
        return
      }
    },
    setFood(parcelGoods: ParcelGoods) {
      if (this.readonly) {
        this.food = parcelGoods.features.toLowerCase() as TFood
        (this.$refs.foodGroup as IFoodGroup).setFood(parcelGoods)
      }
    }
  },
  watch: {
    idCheckValidated: {
      handler() {
        this.emitValidation()
      }
    },
    deskDeliveryValidated: {
      handler() {
        this.emitValidation()
      }
    },
    codValidated: {
      handler() {
        this.emitValidation()
      }
    },
    foodValidated: {
      handler() {
        this.emitValidation()
      }
    },
    sfsChecked: {
      handler() {
        this.setShipFromShop()
      }
    },
    food: {
      handler() {
        this.$emit("foodProduct", this.food)
      }
    },
    isFoodProduct: {
      handler() {
        if (this.isFoodProduct) {
          this.setDefaultFoodProduct()
        }
      }
    },
    "createParcelModel.dpdProduct.type": {
      handler(value) {
        if (value === "DPD_FRESH") {
          this.food = "fresh"
        } else if (value === "DPD_FOOD") {
          this.food = "food"
        } else if (value === "DPD_FROZEN") {
          this.food = "frozen"
        }
      }
    }
  },
  mounted() {
    this.setShipFromShop()
  },
  computed: {
    isFoodProduct(): boolean {
      return ["DPD_FOOD", "DPD_FRESH", "DPD_FROZEN"].includes(this.createParcelModel.dpdProduct.type)
    },
    isFoodProductFresh(): boolean {
      return this.checkFoodProduct("FRESH")
    },
    isFoodProductFood(): boolean {
      return this.checkFoodProduct("FOOD")
    },
    isFoodProductFrozen(): boolean {
      return this.checkFoodProduct("FROZEN")
    },
    showFoodForm(): boolean {
      return this.isFoodProduct
    }
  }
})
